import {
  Box,
  Button,
  DialogActions,
  FormControl,
  TextField,
} from '@mui/material';
import { observer, useLocalObservable } from 'mobx-react-lite';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { v4 as uuidv4 } from 'uuid';
import { action } from 'mobx';
import { VideoCategory } from '../../types/transport';

const AddVideoDialog = observer(
  ({
    currentCategory,
    onClose,
    onSave,
  }: {
    currentCategory: VideoCategory | undefined;
    onClose: () => void;
    onSave: (category: VideoCategory) => void;
  }): JSX.Element => {
    const handleClose = (): void => {
      onClose();
    };

    const formData = useLocalObservable(() => ({
      title: currentCategory?.title || '',
      uuid: currentCategory?.uuid || uuidv4(),
      createdAt: currentCategory?.createdAt || Number(new Date()),
      sortKey: currentCategory?.sortKey || 0,
    }));

    const saveEntry = () => {
      const category: VideoCategory = {
        title: formData.title,
        uuid: formData.uuid,
        createdAt: formData.createdAt,
        sortKey: formData.sortKey,
      };

      onSave(category);
    };

    return (
      <Dialog maxWidth="md" open onClose={handleClose}>
        <DialogTitle>Kategorie hinzufügen</DialogTitle>
        <Box>
          <FormControl>
            <TextField
              id="outlined-basic"
              label="Titel"
              variant="outlined"
              value={formData.title}
              onChange={action(e => {
                formData.title = e.target.value;
              })}
              sx={{ m: 1 }}
            />
            <TextField
              id="outlined-basic"
              label="SortKey"
              variant="outlined"
              type="number"
              inputProps={{ min: '0', max: '100', step: '10' }}
              value={formData.sortKey}
              onChange={action(e => {
                formData.sortKey = Number(e.target.value);
              })}
              sx={{ m: 1 }}
            />
          </FormControl>
        </Box>
        <DialogActions>
          <Button onClick={handleClose}>Abbrechen</Button>
          <Button onClick={saveEntry}>Speichern</Button>
        </DialogActions>
      </Dialog>
    );
  },
);

export default AddVideoDialog;
